module.exports = __webpack_public_path__ + "img/collection-weddingRingsStackingRings@2x.9e9263f.webp";